<template>

	<section class="section-top-border relative">
		<lingo_toolbar_light></lingo_toolbar_light>

		<v-layout column wrap class="" align-center>

			<v-flex xs12 sm4 class="my-5">
				<h1 class="font-weight-thin display-2">Cookie Policy</h1>
			</v-flex>

			<v-flex xs12 class="my-55">
				<v-container grid-list-xl>
					<v-layout row wrap align-center>

						<v-card class="elevation-0" width="900">
							<v-card-title class=" top-border-thin-1 mb-3">



								<div class="card card-emphasised pt-4 pl-4 pr-3 px-20 subheading">

									<h2 id="how-we-share-data" class="blue--text font-weight-light">
										<a name="2"></a>
										What are cookies?
									</h2>

									<p>
										Cookies are small text files (typically made up of letters and
										numbers) placed in the memory of your browser or device when
										you visit a website. They allow a website to
										recognize a particular device or browser. Session-based
										cookies last only while your browser is open and are
										automatically deleted when you close your browser. Persistent
										cookies last until you or your browser delete them or until
										they expire.
									</p>
									<p>
										For further information on deleting, disabling, blocking and
										controlling cookies please visit
										<a href="http://www.allaboutcookies.org">http://www.allaboutcookies.org</a>
									</p>

									<h2 id="how-we-share-data" class="blue--text font-weight-light">
										<a name="2"></a>
										Does Lingo AV use cookies?
									</h2>
									<p>Like many sites, we use cookies to make interactions with
										our Services easy and meaningful. We also use cookies to keep
										you logged in, remember your preferences and allow us to
										provide a more convenient service to you.</p>
									<p>When you use the Lingo AV Services, we and certain partners
										may use cookies to recognize you and to otherwise customize
										your online experiences and other content. For any users of
										our website based outside of the European Economic Area (EEA),
										certain partners use cookies to tailor advertising to your
										preferences. We and certain partners may also use cookies to
										measure the effectiveness of promotions; and mitigate risk and
										prevent potential fraud across the Services. Certain aspects
										and features of the Services are only available through the
										use of Cookies, so if you choose to disable or decline
										Cookies, your use of the Services may be limited or not
										possible.</p>
									<p>Where possible, security measures are set in place to
										prevent unauthorized access to our cookies.</p>

									<h2 id="how-we-share-data" class="blue--text font-weight-light">
										<a name="2"></a>
										How is Lingo AV using cookies?
									</h2>
									<p>We use several types of cookie:</p>

									<table id="privacy-policy-cookie-types" class="table table-bordered">
										<thead>
											<tr>
												<th style="width: 35%">
													Categories
													<span class="hidden-xs"> of Use</span>
												</th>
												<th style="width: 65%">Description</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>
													<strong>Authentication</strong>
												</td>
												<td>If you are signed in to the Services, authentication
													cookies help us personalize your experience and show you
													the right information.</td>
											</tr>
											<tr>
												<td>
													<strong>Security</strong>
												</td>
												<td>We use security cookies to enable and support our
													security features, and to help us detect malicious
													activity.</td>
											</tr>
											<tr>
												<td>
													<strong>Performance, Analytics and Research</strong>
												</td>
												<td>Cookies help us and our third party suppliers to learn
													how well our sites and Services perform. We also use
													performance, analytics and research cookies to understand,
													improve, and investigate products, features, and services.
												</td>
											</tr>
											<tr>
												<td>
													<strong>Advertising</strong>
												</td>
												<td>Some of our third party advertising partners use cookies
													for reporting and fraud detection. If you are based outside
													of the EEA, our third party advertising partners may also
													use cookies to provide you with personalised ads when using
													our website. For further information please see the section
													below on advertising.</td>
											</tr>
										</tbody>
									</table>

									<p></p>
									<h4>What cookies does Lingo AV use?</h4>
									<p>We use the following cookies:</p>

									<table id="privacy-policy-cookie-types" class="table table-bordered">
										<thead>
											<tr>
												<th style="width: 35%">
													Categories
													<span class="hidden-xs"> of Use</span>
												</th>
												<th style="width: 65%">Description</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>
													<strong>Google Analtyics</strong>
													<ul class="list-unstyled">
														<li>
															<code>_utma</code>
														</li>
														<li>
															<code>_utmb</code>
														</li>
														<li>
															<code>_utmc</code>
														</li>
														<li>
															<code>_utmz</code>
														</li>
														<li>
															<code>_qca</code>
														</li>
													</ul>
												</td>
												<td>
													<p>These cookies are used to collect information about how
														visitors use our site. We use the information to compile
														reports and to help us improve the site. The cookies
														collect information in an anonymous form, including the
														number of visitors to the site, where vistors have come to
														the site from and the pages they visited.</p>

													<p>
														<a
															href="http://www.google.co.uk/intl/en/analytics/privacyoverview.html"
															title="Privacy at Google" target="_blank">Click here for an
															overview of privacy at Google</a>
													</p>

													<p>
														To opt out of being tracked by Google Analytics across all
														websites visit:
														<a href="http://tools.google.com/dlpage/gaoptout">http://tools.google.com/dlpage/gaoptout</a>
													</p>
												</td>
											</tr>
											<tr>
												<td>
													<strong>Lingo AV functions</strong>
													<ul class="list-unstyled">
														<li>
															<code>cooktest</code>
														</li>
														<li>
															<code>PHPSESSID</code>
														</li>
														<li>
															<code>uname</code>
														</li>
														<li>
															<code>uid</code>
														</li>
														<li>
															<code>has_converted_file</code>
														</li>
														<li>
															<code>cookieconsent_dismissed</code>
														</li>
														<li>
															<code>design</code>
														</li>
														<li>
															<code>has_used_v2</code>
														</li>
													</ul>
												</td>
												<td>
													<p>These cookies are used by us to help manage load to the
														website (to provide the best possible performance to
														users), to allow users to register for Lingo AV and login,
														and to allow users to switch between old and new website
														designs. They do not contain any personally identifiable
														information.</p>
													<p>
														If you do not wish these cookies to be set then you should
														not use the Lingo AV website. To block cookies from the
														Lingo AV.com domain in your web browser you should follow
														browser instructions at:
														<a
															href="http://www.allaboutcookies.org/manage-cookies/stop-cookies-installed.html">http://www.allaboutcookies.org/manage-cookies/stop-cookies-installed.html
														</a>
													</p>
												</td>
											</tr>
										</tbody>
									</table>

									<h2 id="how-we-share-data" class="blue--text font-weight-light">
										<a name="2"></a>
										How are cookies used for advertising purposes?
									</h2>
									<p>We work with third-party advertising providers to serve ads
										when you are using our Services. If you are based in the EU,
										these providers do not use cookies or other technologies for
										targeting adverts, but some cookies may be used by them for
										frequency capping, aggregated ad reporting and to combat fraud
										and abuse. If you are based outside of the EEA when using our
										website, your web browser may request advertisements and
										beacons directly from third party ad network servers; these
										networks can view, edit, or set third party cookies, just as
										if you had requested a web page from their site.</p>
									<p>If you wish to opt out of the use of such cookies from
										advertising networks please see our section below on removing
										cookies.</p>
									<p>If you are based outside of the EU, please see our section
										below on "Opting out of personalised third party ads".</p>

									<h2 id="how-we-share-data" class="blue--text font-weight-light">
										<a name="2"></a>
										What can you do if you don't want any cookies to be set or
										want them to be removed?
									</h2>
									<p>Some people prefer not to allow cookies, which is why most
										browsers give you the ability to manage cookies to suit you.
										In some browsers you can set up rules to manage cookies on a
										site-by-site basis, giving you more fine-grained control over
										your privacy. What this means is that you can disallow cookies
										from all sites except those that you trust.</p>

									<p>Browser manufacturers provide help pages relating to cookie
										management in their products. Please click on the links below
										for more information on how to manage your cookie settings.
									</p>

									<ul>
										<li>
											<a href="https://support.google.com/chrome/answer/95647?hl=en-GB">Google Chrome</a>
										</li>
										<li>
											<a href="https://support.microsoft.com/en-us/kb/260971">Internet Explorer</a>
										</li>
										<li>
											<a
												href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer">Mozilla Firefox</a>
										</li>
										<li>
											<a href="https://support.apple.com/kb/PH5042?locale=en_US">Safari (Desktop)</a>
										</li>
										<li>
											<a href="https://support.apple.com/en-us/HT201265">Safari (Mobile)</a>
										</li>
										<li>
											<a href="https://support.google.com/android/answer/2425067?hl=en">Android Browser</a>
										</li>
										<li>
											<a href="http://www.opera.com/help">Opera</a>
										</li>
										<li>
											<a href="https://www.opera.com/help/mobile/android#privacy">Opera Mobile</a>
										</li>
									</ul>


									<h2 id="how-we-share-data" class="blue--text font-weight-light">
										<a name="2"></a>
										Tracking
									</h2>
									<h4>Google Analytics</h4>
									<p>We use Google Analytics as a third party tracking service,
										but don't use it to track you individually. We use Google
										Analytics to collect information about how our website
										performs and how our users, in general, navigate through and
										use Lingo AV to help us evaluate our users' use of Lingo AV;
										compile statistical reports on activity; and improve our
										content and website performance.</p>
									<p>We look to protect your privacy by anonymizing your IP
										address prior to sending it to Google Analytics and we only
										gather certain basic information, such as your browser type,
										referring and exit pages, time stamp, and similar data about
										your use of Lingo AV. We do not link this information to any
										of your personal information.</p>
									<p>
										Google provides further information about its own privacy
										practices and offers a
										<a href="https://tools.google.com/dlpage/gaoptout">browser add-on to opt out of Google Analytics
											tracking</a>
										.
									</p>

								</div>

							</v-card-title>
						</v-card>

					</v-layout>
				</v-container>
			</v-flex>
		</v-layout>

		<lingo_footer_light class="mt-5"></lingo_footer_light>
	</section>



</template>

<script>
	import lingo_toolbar_light from './ToolbarLight';
	import lingo_footer_light from './FooterLight';

	export default {
	name: "cookiePolicy",
	data() {
	return {

	};
	},
	components: {
	lingo_toolbar_light,
	lingo_footer_light
	}
	};
</script>


